enum ProductOrderStatus {
    CREATED="CREATED",
    PROCESSING="PROCESSING",
    DELIVERED="DELIVERED",
}

export default ProductOrderStatus;